import React, { useEffect } from "react";
import { Range } from "rc-slider";
import IDataFilterRangeValue from "./IDataFilterRangeValue";
import styles from "./datafilterrange.module.scss";
import "rc-slider/assets/index.css";
import FormGroup from "features/shared/forms/components/FormGroup";
import IDataFilterProps from "../IDataFilterProps"
import { useTranslation } from "react-i18next";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";


const DataFilterRangeBox = (props: IDataFilterProps) => {
  // translations
  const tLables = useTranslation("shared\\dataFilters").t;

  const setDescriptorValue = (name: string, value: number[]) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === name);

    // Nastavím hodnotu
    const range = descriptor?.value as IDataFilterRangeValue;
    range.value = value;

    props.setDescriptors(newDescriptors);
  };

  const setDescriptorValueBoundary = (
    name: string,
    min: number,
    max: number
  ) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === name);

    // Nastavím hodnotu
    const range = descriptor?.value as IDataFilterRangeValue;
    range.value = [min, max];
    range.min = min;
    range.max = max;

    props.setDescriptors(newDescriptors);
  };

  const handleOnChangeRangeBox = (value: number[], name: string) => {
    if (value[0] === 0 && value[1] === 0) return;
    setDescriptorValue(name, value);
  };

  const setValueBoundary = () => {
    const descriptorValue = props.filterDescriptor
      .value as IDataFilterRangeValue;

    if (
      descriptorValue.external &&
      props.externalData &&
      props.externalData.length > 0
    ) {
      const externalDataValue = props.externalData.find(
        (x) => x.name === props.filterDescriptor.name
      );
      if (externalDataValue) {
        const data = externalDataValue.data as number[];

        if (descriptorValue.min === data[0] && descriptorValue.max === data[1])
          return;

        setDescriptorValueBoundary(
          props.filterDescriptor.name,
          data[0],
          data[1]
        );
      }
    }
  };

  const handleOnChangeValueInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    currentRange: number[],
    descriptorName: string
  ) => {
    let newValues = currentRange;

    if (e.target.id === "rangeValueFrom") {
      newValues[0] = Number.parseInt(e.target.value) || 0;
    } else {
      newValues[1] = Number.parseInt(e.target.value) || 0;
    }

    setDescriptorValue(descriptorName, newValues);
  };

  const handleOnBlurValueInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    currentRange: number[],
    descriptorName: string
  ) => {
    // Kontrola min / max
    const newValues = switchRange(currentRange);
    setDescriptorValue(descriptorName, newValues);
  };

  // Pokud je hodnota min větší než max, tak ji přehodím
  const switchRange = (currentRange: number[]): number[] => {
    if (currentRange[0] > currentRange[1]) {
      return [currentRange[1], currentRange[0]];
    }

    return currentRange;
  };

  useEffect(() => {
    setValueBoundary();
  }, []);

  const rangeValue = props.filterDescriptor.value as IDataFilterRangeValue;
  return (
    <FormGroup key={props.reactKey} labelText={getTranslatedFormText(props.filterDescriptor, "label", tLables)}>
      <div className={styles.rangeSlider}>
        <Range
          className={styles.customRcSlider}
          min={rangeValue.min}
          max={rangeValue.max}
          value={rangeValue.value}
          onChange={(value) =>
            handleOnChangeRangeBox(value, props.filterDescriptor.name)
          }
        />
      </div>

      <div className="row no-gutters">
        <div className="col pr-2">
          <div className="input-group">
            <input
              id="rangeValueFrom"
              type="number"
              value={rangeValue.value[0]}
              className="form-control"
              aria-describedby="rangeFrom"
              onChange={(event) =>
                handleOnChangeValueInput(
                  event,
                  rangeValue.value,
                  props.filterDescriptor.name
                )
              }
              onBlur={(event) =>
                handleOnBlurValueInput(
                  event,
                  rangeValue.value,
                  props.filterDescriptor.name
                )
              }
            />
          </div>
        </div>

        <div className="col pl-2">
          <div className="input-group">
            <input
              id="rangeValueTo"
              type="number"
              value={rangeValue.value[1]}
              className="form-control"
              aria-describedby="rangeTo"
              onChange={(event) =>
                handleOnChangeValueInput(
                  event,
                  rangeValue.value,
                  props.filterDescriptor.name
                )
              }
              onBlur={(event) =>
                handleOnBlurValueInput(
                  event,
                  rangeValue.value,
                  props.filterDescriptor.name
                )
              }
            />
          </div>
        </div>
      </div>
    </FormGroup>
  );
};

export default DataFilterRangeBox;
